// Components==============
import indexCategories from 'actions/category/index';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useContext, useEffect, useState } from 'react';
import { FilterType, TranslateType } from 'typings';
import { FilterContext } from '../../FilterMenu';
// =========================

export default function CategoryDropdown({
  initialText,
  id,
}: {
  initialText: TranslateType;
  id: number;
}) {
  const { setFilterValues, triggerReset } = useContext(FilterContext);
  const dispatch = useReduxAction();

  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    dispatch(indexCategories());
  }, []);

  const categories = useRedux((state) =>
    state.category?.entities.allIds.map(
      (skillId) => state.category?.entities.byId[skillId]
    )
  );

  const options = categories?.map((category) =>
    category?.name ? category?.name : ''
  );

  useEffect(() => setSelected([]), [triggerReset]);

  useEffect(() => {
    const newValue = categories
      ?.filter((category) =>
        category?.name ? selected.includes(category?.name) : false
      )
      .map((category) => category?.id);

    setFilterValues(
      (prev) =>
        prev.map((val) =>
          val.id === id ? { ...val, value: newValue } : val
        ) as FilterType[]
    );
  }, [selected]);

  return (
    <Dropdown
      initialText={initialText}
      selectedItems={selected}
      setSelectedItems={setSelected}
      initialOptions={options || []}
    />
  );
}
